export const getSiteId = (state) => state.main.siteId;
export const getAuthToken = (state) => state.login.token;
